import React from "react";
import _ from "lodash";
import Tooltip from "rc-tooltip";
import styled from "styled-components";
import Highchart from "./Highchart";
import QuestionCircle from "./icons/QuestionCircle";
import {
  BinomialConfiguration,
  LogisticConfiguration,
  MixedModelConfiguration
} from "./charts/ModelBasedAlertingConfigs";
import ModelTypes from "../constants/modelTypes";
import rem from "../utils/rem";

const Wrapper = styled.div`
  width: 100%;
`;

const TooltipWrapper = styled.span`
  position: relative;
  top: 30px;
  left: 10px;
  z-index: 500;
`;

const NoDataWrapper = styled.div`
  padding-top: ${rem(20)};
`;

class ModelBasedAlertingChart extends React.Component {
  render() {
    const { data } = this.props.data;

    if (_.isEmpty(data)) {
      return <NoDataWrapper>No data for this selection</NoDataWrapper>;
    }

    const configs = _.chain(data)
      .groupBy(model => JSON.stringify([model.venueName, model.direction]))
      .mapValues(models => {
        return _.chain(models)
          .sortBy(["model"])
          .map(model => {
            switch (model.model) {
              case ModelTypes.BINOMIAL:
                return BinomialConfiguration(model);
              case ModelTypes.LOGISTIC:
                return LogisticConfiguration(model);
              case ModelTypes.MIXED_MODEL:
                return MixedModelConfiguration(model);
              default:
                return {};
            }
          })
          .value();
      })
      .value();

    return (
      <Wrapper>
        {_.map(configs, (configs, key, idx) => {
          const [venueName, direction] = JSON.parse(key);

          const charts = configs.map((config, idx) => {
            return (
              <React.Fragment key={idx}>
                <Tooltip
                  placement="bottomLeft"
                  trigger={["hover"]}
                  overlay={
                    <div style={{ maxWidth: "300px" }}>
                      {config.modelDescription}
                    </div>
                  }
                >
                  <TooltipWrapper>
                    <QuestionCircle />
                  </TooltipWrapper>
                </Tooltip>
                <Highchart
                  containerId={`charts-${key}-${idx}`}
                  options={config}
                />
              </React.Fragment>
            );
          });
          return (
            <div key={key}>
              <h3>{`${venueName} - ${_.capitalize(direction)}`}</h3>
              {charts}
            </div>
          );
        })}
      </Wrapper>
    );
  }
}

export default ModelBasedAlertingChart;



// WEBPACK FOOTER //
// ./src/components/ModelBasedAlertingChart.js